import { render, staticRenderFns } from "./home-head.vue?vue&type=template&id=61a1047a&scoped=true&"
import script from "./home-head.vue?vue&type=script&lang=js&"
export * from "./home-head.vue?vue&type=script&lang=js&"
import style0 from "./home-head.vue?vue&type=style&index=0&id=61a1047a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a1047a",
  null
  
)

export default component.exports